var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"copyright"},[_vm._v("\n    Divinitor Devlin © 2019 Vahr (Vincent Zhang)\n")])}
var staticRenderFns = []

export { render, staticRenderFns }